module.exports = __webpack_public_path__ + "static/media/logo-arbitr-full-en.41e62dc9.svg";